import { NgxSpinnerService } from 'ngx-spinner';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, NavigationStart } from '@angular/router';
import { HeaderComponent } from '../../partials/header/header.component';
import { HomeComponent } from './home/home.component';
import { PracticeExamComponent } from './exam/practice-exam/practice-exam.component';
import { GuardService } from '../auth/guard/guard.service';

const routes: Routes = [
  {
    path: '',
    component: HeaderComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'seasons',
        loadChildren: () => import('./season-list/season-list.module').then(m => m.SeasonListModule),
        data: { animation: 'openClosePage' },
        canActivate: [GuardService],
      },
      {
        path: 'azmoon',
        loadChildren: () => import('./exam/exam.module').then(m => m.ExamModule),
        data: { animation: 'statusPage' },
        canActivate: [GuardService],
      },
      {
        path: 'practice-exam',
        loadChildren: () => import('./exam/practice-exam/practice-exam.module').then(m => m.PracticeExamModule),
        component: PracticeExamComponent,
        canActivate: [GuardService],

      },
      {
        path: 'profile',
        loadChildren: () => import('../profile/profile.module').then(m => m.ProfileModule),
        canActivate: [GuardService],
      },
      {
        path: 'course-list',
        loadChildren: () => import('./course-list/course-list.module').then(m => m.CourseListModule),
        canActivate: [GuardService],
      },
      {
        path: 'course-item',
        loadChildren: () => import('./course-list/course-item/course-item.module').then(m => m.CourseItemModule),
        canActivate: [GuardService],
      },
      {
        path: 'teacher',
        loadChildren: () => import('./course-list/single-course/single-course.module').then(m => m.SingleCourseModule),
        data: { animation: 'togglePage' }
      },
      {
        path: 'course-detail',
        loadChildren: () => import('./course-list/course-video-detail/course-video-detail.module').then(m => m.CourseVideoDetailModule),
        data: { animation: 'togglePage' }
      },
      {
        // path: 'blog-list',
        // loadChildren: () => import('../blog-list/blog-list.module').then(m => m.BlogListModule),
        // loadChildren: () => import('../blog/blog.module').then(m => m.BlogModule),

      },
      {
        path: 'about',
        loadChildren: () => import('./about/about.module').then(m => m.AboutModule),
      },
      {
        path: 'feedback',
        loadChildren: () => import('./../../pages/feedback/feedback.module').then((m) => m.FeedbackModule)
      },
      // {
      //   path: 'mentors',
      //   loadChildren: () => import('./').then(m => m.AboutModule),
      // },
      // {
      //   path: 'counseling',
      //   component: CounselingComponent,
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {
  routeSubscription;
  constructor(private router: Router, private loader: NgxSpinnerService) {
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // this.loader.show()
        // setTimeout(() => {
        //   this.loader.hide()
        // }, 1000);
      }
    });
  }
}
